import fn from '../../lib/fn.js';
import dom from '../../lib/dom.js';

export default function setupLinkToCheckboxAndRadioButtonTrigger() {
    function checkCheckBoxAndRadioButtons(ele) {
        if (!ele.disabled && (ele.type !== 'radio' || ele.checked === false)) {
            // Hack to make this work cross browser.
            // All IE browsers will check checkbox when click is fired. This does not Chrome, Firefox and Safari.
            if (/Edge/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /MSIE 10/i.test(navigator.userAgent)) {
                dom.fire(ele, 'click');
            } else {
                ele.checked = !ele.checked;
                dom.fire(ele, 'click');
            }
        }
    }

    fn.forEach(dom.byQuerySelector('[data-link-to-checkboxes]', document), (root) => {
        dom.on(root, 'click', 'a', (e) => {
            let checkbox;
            try {
                checkbox = dom.byQuerySelector("input[type='checkbox']", dom.closestWithClass('fancyinput', e.target))[0];
            } catch (err) {
                return;
            }

            e.preventDefault();
            checkCheckBoxAndRadioButtons(checkbox);
        });
    });

    fn.forEach(dom.byQuerySelector('[data-link-to-radiobuttons]', document), (root) => {
        dom.on(root, 'click', 'a', (e) => {
            let radiobutton;
            try {
                radiobutton = dom.byQuerySelector("input[type='radio']", dom.closestWithTagName('label', e.target))[0];
            } catch (err) {
                return;
            }
            e.preventDefault();
            checkCheckBoxAndRadioButtons(radiobutton);
        });
    });
}
